import Background from '@assets/static-glitch.gif';
import React from 'react';
import styled from 'styled-components';
import { H2, H6 } from '../../../components/Typography/Typography';
import { CurvedArrow } from '../../../icons/Icons';
import { TopNotch } from '../../../components/GlobalStyles';
import { media } from '../../../components/style-utils';

export const SectionMoment = function() {
  return (
    <Container>
      <Image src={Background} />
      <TopNotch color="white" />
      <TextBox>
        <Headline>
          The church is having a moment <em>right now</em>. <U>Limitation</U> is making a way for <U>innovation</U>{' '}
          this&nbsp;year.
        </Headline>
        <Question>AND THE RESULTS?</Question>
        <ResultList style={{ listStyleType: 'disc', listStylePosition: 'inside' }}>
          <ResultItem>Digital platforms being used to fulfill the Church’s mission</ResultItem>
          <ResultItem>Senior leaders waking up to the power of social media</ResultItem>
          <ResultItem>Life change taking place in ways churches have never seen before</ResultItem>
        </ResultList>
        <StyledArrow />
      </TextBox>
    </Container>
  );
};

const Container = styled.section`
  position: relative;
  width: 100vw;
  color: var(--colorWhite);
  background-color: var(--colorBlack);
`;

const Image = styled.div`
  position: absolute;
  z-index: 1;

  width: 100%;
  height: 100%;

  opacity: 0.35;
  background-image: url(${(props) => props.src});
  background-size: cover;
`;

const Headline = styled(H2)``;

const Question = styled(H6)`
  margin-top: 4rem;
`;

const ResultList = styled.ul`
  max-width: 30rem;

  ${media.tabletPortraitAndUp`
    max-width: 80rem;
  `}
`;

const ResultItem = styled.li`
  margin: 2rem 0;

  ${media.tabletPortraitAndUp`
    margin: 0;
  `}
`;

const StyledArrow = styled(CurvedArrow)`
  display: none;
`;

const TextBox = styled.div`
  position: relative;
  z-index: 2;

  max-width: 44rem;
  padding: 10rem 2rem 12rem;
  margin: 0 auto;

  ${media.tabletPortraitAndUp`
    max-width: 80rem;
  `}
`;

const U = styled.span`
  text-decoration: underline;
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionMoment.js